import { BaseStoreState } from 'reducer/baseStoreState';

export enum DownloadShareholderDocumentActionTypes {
    DOWNLOAD_SHAREHOLDER_DOCUMENT_REQUEST = '@@shareholder/DOWNLOAD_SHAREHOLDER_DOCUMENT_REQUEST',
    DOWNLOAD_SHAREHOLDER_DOCUMENT_SUCCESS = '@@shareholder/DOWNLOAD_SHAREHOLDER_DOCUMENT_SUCCESS',
    DOWNLOAD_SHAREHOLDER_DOCUMENT_ERROR = '@@shareholder/DOWNLOAD_SHAREHOLDER_DOCUMENT_ERROR',
    DOWNLOAD_SHAREHOLDER_DOCUMENT_RESET_STATE = '@@shareholder/DOWNLOAD_SHAREHOLDER_DOCUMENT_RESET_STATE'
}

export interface DownloadShareholderDocumentState extends BaseStoreState {
    readonly shareholderDocument?: Uint8Array;
}
